import React, { useEffect } from "react";
import { DNA } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { getDefaultRouteForRole } from "../../utils/roleAccess";

const Authentication = ({ children, allowedRoles }) => {
  const { isAuthenticated, loading, user } = useSelector(
    (state) => state.authState
  );

  const isRoleAllowed =
    !allowedRoles?.length || allowedRoles.includes(user?.role);

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        window.location.href = "/login";
        return;
      }

      if (!isRoleAllowed) {
        window.location.href = getDefaultRouteForRole(user?.role);
      }
    }
  }, [isAuthenticated, isRoleAllowed, loading, user?.role]);

  return (
    <>
      {loading ? (
        <div className="loading">
          <DNA
            visible={true}
            height="100"
            width="100"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : !isAuthenticated || !isRoleAllowed ? null : (
        children
      )}
    </>
  );
};

export default Authentication;
